import { API_ROUTE_ADMIN_DEACTIVATE_FEATURE } from '@/resources/api-routes'
import { post } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export const deactivateFeature = async ({
  featureId,
  customerId,
}: {
  featureId: number
  customerId: number
}) =>
  post<null>(
    API_ROUTE_ADMIN_DEACTIVATE_FEATURE.replace(':featureId', String(featureId)),
    { customerId },
    IS_NEW_BACKEND_API
  )
